import comprasAssinaturas from './comprasAssinaturas.routes';
import reembolso from './reembolso.routes';
import rastreio from './rastreio.routes';
// [FUS-2753] rota do chat desregistrada (homeserver Matrix descomissionado).
// O arquivo chat.routes.js e os componentes de Chat/ seguem no repo; para reativar,
// restaurar o import e a linha "...chat" abaixo.
// import chat from './chat.routes';

const routes = [
  ...comprasAssinaturas,
  ...reembolso,
  ...rastreio,
  // ...chat,
];

export default routes;
